import styled, { css } from 'styled-components';
import { Screen, screenBiggerThan } from '@client/styles/styled-components/breakpoints';
import { colorExtraLight } from '@client/styles/styled-components/variables';
import { Spacer } from '@lux/tokens';
import { Message } from '@lux/message';

export const OuterWrapper = styled.div<{
    isM1Rebranding: boolean;
    shouldRenderGRETreatment: boolean;
    isGRETab: boolean;
}>`
    ${({ isGRETab, shouldRenderGRETreatment }) =>
        isGRETab &&
        shouldRenderGRETreatment &&
        `
    position: sticky;
    top: 110px;
    z-index: 1;
    box-shadow: rgba(0, 0, 0, 0.12) 0px 2px 4px;
    `};

    ${({ isM1Rebranding }) =>
        isM1Rebranding
            ? `
        margin-bottom: ${Spacer.S};
        ${screenBiggerThan(Screen.smallTablet)} {
            margin-bottom: 24px;
        }`
            : `
        margin-bottom: 75px;
        margin-top: 0;
        ${screenBiggerThan(Screen.smallTablet)} {
            margin-bottom: 90px;
            margin-top: 0;
        }
    `}
`;

export const AlertBannerWrapper = styled.div`
    position: absolute;
    width: 100%;
    z-index: 30;
`;

export const DarkModeWrapper = styled.div`
    position: relative;
    width: 100%;
    z-index: 30;
`;

export const StylesMessage = styled(Message)`
    padding: 0 16px;
`;

export const Wrapper = styled.div<{
    shouldRenderGRETreatment: boolean;
    isMainTab: boolean;
    isGRETab: boolean;
}>`
    position: relative;
    overflow: hidden;
    width: 100%;
    height: 400px; // Default Height, Modified below for gre experiments.

    // This is the height of the banner when the GRE Experiment is active and user is on the main tab
    // Find more detail about this experiment here
    // https://docs.google.com/document/d/1H-B1BNx5v4_A2HHI9Re7VnPv8APthCjT7rIvmBzWmAE
    ${({ shouldRenderGRETreatment, isMainTab }) => {
        return (
            shouldRenderGRETreatment &&
            isMainTab &&
            `
                height: 12.5rem;
            `
        );
    }};

    // This is the height of the banner when the GRE Experiment is active and user is on the GRE tab
    // isGreTab true -> tab.globalRetailEvent is true
    // Find more detail about this experiment here
    // https://docs.google.com/document/d/1H-B1BNx5v4_A2HHI9Re7VnPv8APthCjT7rIvmBzWmAE
    ${({ isGRETab, shouldRenderGRETreatment }) => {
        return (
            isGRETab &&
            shouldRenderGRETreatment &&
            `
                height: 80px;
            `
        );
    }};

    ${screenBiggerThan(Screen.smallTablet)} {
        height: 335px;
    }
    ${screenBiggerThan(Screen.tablet)} {
        height: 500px;
    }
`;

interface TabsWrapperProps {
    readonly floating: boolean;
    readonly floatingHidden: boolean;
    readonly smartbannerVisibility: boolean;
}

export const CommercialWrapper = styled.div<{ floating: boolean; floatingHidden: boolean }>`
    position: fixed;
    top: 60px;
    width: 100%;
    z-index: 101;
    transition: top 0.15s linear;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);

    ${screenBiggerThan(Screen.smallTablet)} {
        top: 75px;
    }

    ${({ floating, floatingHidden }) =>
        floating &&
        css`
            top: ${floatingHidden ? 60 : 110}px;
            z-index: 1001;

            ${screenBiggerThan(Screen.smallTablet)} {
                margin-top: 0;
                top: ${floatingHidden ? 75 : 125}px;
            }
        `}

    &.commercial-transition-enter, &.commercial-transition-exit {
        z-index: 101;
        transition: top 0.15s linear, transform 0.3s ease-out;
    }

    &.commercial-transition-enter {
        transform: translateY(-100%);
    }

    &.commercial-transition-enter-active,
    &.commercial-transition-enter-done {
        transform: translateY(0);
    }

    &.commercial-transition-exit,
    &.commercial-transition-exit-done {
        transform: translateY(-100%);
    }
`;

export const TabsWrapper = styled.div<TabsWrapperProps>`
    width: 100%;
    position: absolute;
    transition: top 0.25s linear;
    overflow: hidden;
    height: 50px;
    background-color: ${colorExtraLight};
    margin: 15px 0 10px;

    ${screenBiggerThan(Screen.smallTablet)} {
        margin: 20px 0;
    }

    ${({ floating, smartbannerVisibility }) =>
        floating &&
        `
        position: fixed;
        z-index: 1000;
        box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
        top: ${smartbannerVisibility ? 120 : 60}px;
        margin-top: 0;
        ${screenBiggerThan(Screen.smallTablet)} {
            margin-top: 0;
            top: ${smartbannerVisibility ? 135 : 75}px;
        }
    `}

    ${({ floatingHidden }) =>
        floatingHidden &&
        `
        top: 10px;
        box-shadow: none;
        ${screenBiggerThan(Screen.smallTablet)} {
            top: 25px;
        }
    `}
`;

export const SpinnerWrapper = styled.div`
    width: 100%;
    margin: 60px auto 30px;
    display: flex;
    justify-content: center;

    ${screenBiggerThan(Screen.smallTablet)} {
        margin-top: 75px;
    }
`;
